import React from 'react'

import { useIntl } from 'react-intl'
import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import s from './s.module.css'
import { lang } from './lang'
import { globalLang } from '~globalLang'
import ModalView from '~components/ModalView'

interface Props {
    onClose: () => void
}

function Content({ onClose }: Props) {
    const intl = useIntl()

    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Unfreeze} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="freeze_alert"
            contentClassName={s.hack}
        >
            <div className={s.button}>
                <Button dataPointer="cancel" size="l" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.cancel} />
                </Button>
                <Button dataPointer="contact" size="l" mode="primary" href={supportLink} role="anchor" fullWidth>
                    <FormattedHTMLMessage {...lang.contact} />
                </Button>
            </div>
        </ModalView>
    )
}

export default Content
